import { api, handleError } from "./baseApi";
import Cookies from "js-cookie";
export async function sendOtp(user_type, phone_number) {
  try {
    const { data } = await api.post(`/${user_type}/login/initiate`, {
      phone_number,
    });
    return data;
  } catch (error) {
    return handleError(error);
  }
}

export async function verifyOtp(user_type, user_id, otp) {
  try {
    const { data } = await api.post(`/${user_type}/login/verify`, {
      user_id,
      otp,
    });
    return data;
  } catch (error) {
    return handleError(error);
  }
}

export async function validateTokenOnLaunch() {
  try {
    const { data } = await api.get("/admin/login/validate");
    return data;
  } catch (error) {
    return handleError(error);
  }
}

export async function refreshToken() {
  try {
    const { data } = await api.post("/admin/login/refresh", {
      refresh_token: Cookies.get("refreshToken"),
    });
    return data;
  } catch (error) {
    return handleError(error);
  }
}
